<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.keyword"
        placeholder="关键字搜索(账号、姓名、证件号码)"
        style="width: 300px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.userId"
        placeholder="会员ID搜索"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.gradeId"
        placeholder="等级"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option v-for="item in gradeOption" :key="item.id" :label="item.name" :value="item.id" />
      </el-select>
      <el-select
        v-model="listQuery.status"
        placeholder="账号状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in MEMBER_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-select
        v-model="listQuery.certStatus"
        placeholder="实名认证状态"
        style="width: 160px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in MEMBER_CER_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <DataPicker
        @valueFunc="getPickerValueFunc"
        paramsType="create"
        startPlaceholder="注册开始时间"
        endPlaceholder="注册截止时间"
      />
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
      <el-button class="filter-item" type="primary" @click="checkDialogFormVisible(true)"
        >新增会员</el-button
      >
      <el-button
        class="filter-item"
        icon="el-icon-download"
        @click="handleExport"
        style="margin-left: 10px"
        >导出</el-button
      >
    </div>
    <div style="margin-bottom: 5px">会员数量:{{ total }}</div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" prop="id" label="会员编号" width="95"></el-table-column>
      <el-table-column
        align="center"
        prop="parentId"
        label="上级会员编号"
        width="95"
      ></el-table-column>
      <el-table-column label="姓名" align="center" prop="name" width="100"></el-table-column>
      <el-table-column label="性别" align="center" prop="gender" width="100"></el-table-column>
      <el-table-column
        label="出生日期"
        align="center"
        prop="birthday"
        width="100"
      ></el-table-column>
      <el-table-column label="头像URL" align="left" prop="avatarUrl" width="100">
        <template slot-scope="scope">
          <el-image
            style="width: 100px; height: 100px"
            :src="scope.row.avatarUrl"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="agentName" label="代理商级别" width="120">
      </el-table-column>
      <el-table-column label="手机号码" align="center" prop="mobile" width="120"></el-table-column>
      <el-table-column
        label="邀请码"
        align="center"
        prop="inviteCode"
        width="120"
      ></el-table-column>
      <el-table-column label="证件号码" align="center" prop="certNo" width="200"></el-table-column>
      <el-table-column class-name="status-col" label="状态" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'danger' : 'success'">{{
            getValue(MEMBER_STATUS, scope.row.status)
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="等级名称" align="center" prop="gradeName"> </el-table-column>
      <el-table-column label="等级值" align="center" prop="gradeLevel"> </el-table-column>
      <el-table-column label="实名认证状态" align="center" prop="certStatus" width="120">
        <template slot-scope="scope">
          {{ getValue(MEMBER_CER_STATUS, scope.row.certStatus) }}
        </template>
      </el-table-column>

      <el-table-column label="合同状态" align="center" prop="contractStatus" width="120">
        <template slot-scope="scope">
          {{ getValue(CONTRACT_STATUS_LIST, scope.row.contractStatus) }}
        </template>
      </el-table-column>

      <el-table-column align="center" prop="ctdate" label="注册时间" width="180">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="260"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="jumpExamine(scope.row)"
            class="comm_but_warp"
            v-if="scope.row.certStatus === 1"
            >审核</el-button
          >
          <el-button
            :type="scope.row.status === 0 ? 'danger' : ''"
            size="mini"
            plain
            @click="checkStatus(scope.row)"
            class="comm_but_warp"
            >{{ scope.row.status === 0 ? "冻结" : "解冻" }}</el-button
          >
          <el-button
            type="success"
            size="mini"
            @click="checkUserAccountVisible(true, scope.row)"
            class="comm_but_warp"
            >余额</el-button
          >
          <el-button
            type="primary"
            size="mini"
            @click="checkJuniorsVisible(true, scope.row)"
            class="comm_but_warp"
            >会员下级</el-button
          >
          <el-button
            type="primary"
            size="mini"
            @click="onAgentSetting(scope.row)"
            class="comm_but_warp"
            >代理商设置</el-button
          >
          <el-button
            type="success"
            size="mini"
            @click="setAgent(true, scope.row)"
            class="comm_but_warp"
            v-if="scope.row.isAgentLogin != 3"
            >设置大区代理</el-button
          >
          <el-button type="success" size="mini" @click="onCheck(scope.row)" class="comm_but_warp"
            >查询业绩</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!--    新增会员-->
    <el-dialog
      title="新增会员"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="60%"
      @close="checkDialogFormVisible(false)"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="150px"
        style="width: 80%; margin-left:50px;"
      >
        <el-form-item label="手机号码" prop="mobile">
          <el-input v-model="form.mobile" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="登录密码" prop="password">
          <el-input v-model="form.password" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="邀请码" prop="inviteCode">
          <el-input v-model="form.inviteCode" placeholder="请输入" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkDialogFormVisible(false)">取消</el-button>
        <el-button type="primary" @click="saveAddOrEditData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!--    充值会员列表-->
    <el-dialog
      title="账户余额列表"
      :visible.sync="userAccountVisible"
      :close-on-click-modal="false"
      width="60%"
    >
      <el-table
        v-loading="userAccountLoading"
        :data="userAccountList"
        element-loading-text="Loading"
        size="small"
        border
        fit
        highlight-current-row
      >
        <el-table-column label="账户名称" align="center" prop="name"></el-table-column>
        <el-table-column label="活期账户余额" align="center" prop="curAmount"> </el-table-column>
        <el-table-column label="锁定账户余额" align="center" prop="lockAmount"></el-table-column>
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="checkRechargeVisible(true, scope.row)"
              class="comm_but_warp"
              >充值</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="checkUserAccountLogVisible(true, scope.row)"
              class="comm_but_warp"
              >账户流水</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="checkUserAccountVisible(false)">确定</el-button>
      </div>
    </el-dialog>

    <!--    充值会员-->
    <el-dialog
      title="会员充值"
      :visible.sync="rechargeVisible"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form
        ref="rechargeForm"
        :rules="rechargeRules"
        :model="rechargeForm"
        label-position="left"
        label-width="150px"
        style="width: 80%; margin-left:50px;"
      >
        <el-form-item label="账户类型" prop="type">
          <el-select
            v-model="rechargeForm.type"
            placeholder="请选择"
            style="width: 100%"
            class="filter-item"
            clearable
          >
            <el-option
              v-for="item in ACCOUNT_TYPE.filter(item => ['lock', 'current'].includes(item.key))"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="充值金额" prop="amount">
          <el-input v-model="rechargeForm.amount" placeholder="请输入" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkRechargeVisible(false)">取消</el-button>
        <el-button type="primary" @click="saveRechargeData" :loading="rechargeBtnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!--  会员账户流水 -->
    <el-dialog
      title="会员账户流水"
      :visible.sync="userAccountLogVisible"
      :close-on-click-modal="false"
      width="60%"
      @close="checkUserAccountLogVisible(false, {})"
    >
      <el-tabs v-model="accountLogActive" type="card" @tab-click="handleAccountLogClick">
        <el-tab-pane label="活期账户" name="cur"></el-tab-pane>
        <el-tab-pane label="锁定账户" name="lock"></el-tab-pane>
      </el-tabs>
      <el-table
        v-loading="userAccountLogLoading"
        :data="userAccountLogList"
        element-loading-text="Loading"
        size="small"
        border
        fit
        highlight-current-row
      >
        <el-table-column label="类型" align="center" prop="type">
          <template slot-scope="scope">
            {{ getValue(BALANCE_TYPE, scope.row.type) }}
          </template>
        </el-table-column>
        <el-table-column label="变更金额" align="center" prop="amount"> </el-table-column>
        <el-table-column label="备注" align="center" prop="remark"></el-table-column>
        <el-table-column align="center" prop="ctdate" label="时间" width="180">
          <template slot-scope="scope">
            <i class="el-icon-time" />
            <span>{{ formatApiDate(scope.row.ctdate) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          :current-page="userAccountLogForm.page"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="userAccountLogForm.pageSize"
          :total="userAccountLogTotal"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeLogChange"
          @current-change="handleCurrentLogChange"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="checkUserAccountLogVisible(false, {})">确定</el-button>
      </div>
    </el-dialog>

    <!--  下级会员列表 -->
    <el-dialog
      title="下级会员列表"
      :visible.sync="juniorsVisible"
      :close-on-click-modal="false"
      width="60%"
      @close="checkJuniorsVisible(false, {})"
    >
      <el-table
        v-loading="juniorsLoading"
        :data="juniorsList"
        element-loading-text="Loading"
        size="small"
        border
        fit
        highlight-current-row
      >
        <el-table-column label="当前用户编号" align="center" prop="userId"> </el-table-column>
        <el-table-column label="上级用户编号" align="center" prop="parentId"> </el-table-column>
        <el-table-column label="用户名称" align="center" prop="userName"></el-table-column>
        <el-table-column label="手机号码" align="center" prop="userMobile"></el-table-column>
        <el-table-column label="用户等级" align="center" prop="gradeName"></el-table-column>
        <el-table-column label="用户值" align="center" prop="gradeLevel"></el-table-column>
        <el-table-column
          label="用户消费金额"
          align="center"
          prop="userCastAmount"
        ></el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="260"
          fixed="right"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="checkJuniorsStatisticsVisible(true, scope.row)"
              class="comm_but_warp"
              >下级统计</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          :current-page="juniorsForm.page"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="juniorsForm.pageSize"
          :total="juniorsTotal"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleJuniorsSizeChange"
          @current-change="handleJuniorsCurrentChange"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="checkJuniorsVisible(false, {})">确定</el-button>
      </div>
    </el-dialog>

    <!--  下级会员列表 -->
    <el-dialog
      title="下级会员统计"
      :visible.sync="juniorsStatisticsVisible"
      :close-on-click-modal="false"
      width="30%"
      @close="checkJuniorsStatisticsVisible(false, {})"
    >
      <el-descriptions :column="2" border>
        <el-descriptions-item
          label="团队总人数"
          :span="2"
          label-class-name="my-label"
          content-class-name="my-content"
          >{{ juniorsStatisticsObj.teamCount }}</el-descriptions-item
        >
        <el-descriptions-item label="直推下级人数">{{
          juniorsStatisticsObj.ztCount
        }}</el-descriptions-item>
        <el-descriptions-item label="间推下级人数">{{
          juniorsStatisticsObj.jtCount
        }}</el-descriptions-item>
        <el-descriptions-item label="下级订单数量">{{
          juniorsStatisticsObj.teamNum
        }}</el-descriptions-item>
        <el-descriptions-item label="下级订单金额">{{
          juniorsStatisticsObj.teamAmount
        }}</el-descriptions-item>
        <el-descriptions-item label="我的订单数量">{{
          juniorsStatisticsObj.myNum
        }}</el-descriptions-item>
        <el-descriptions-item label="我的订单金额">{{
          juniorsStatisticsObj.myAmount
        }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="checkJuniorsStatisticsVisible(false, {})">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="isDai" :append-to-body="true">
      <div class="dialog-view" v-if="curRow">
        <span style="font-size:30px;" class="dia-pos">代理商设置</span>
        <div class="dialog-content">
          <div class="dialog-left">
            会员ID:
          </div>
          <div class="dialog-right">
            {{ curRow.id }}
          </div>
        </div>
        <div class="dialog-content" style="margin-top:20px">
          <div class="dialog-left">
            会员姓名:
          </div>
          <div class="dialog-right">
            {{ curRow.name }}
          </div>
        </div>
        <div class="dialog-content" style="margin-top:20px">
          <div class="dialog-left">
            代理商级别:
          </div>
          <div class="dialog-right">
            <el-select
              v-model="selectValue"
              placeholder="请选择"
              style="width: 120px"
              class="filter-item"
              clearable
            >
              <el-option
                v-for="item in daiList"
                :key="item.id"
                :label="item.agentName"
                :value="item.id"
              />
            </el-select>
          </div>
        </div>
      </div>
      <el-button @click="onClose">取 消</el-button>
      <el-button type="primary" @click="onDaiShe">确 定</el-button>
    </el-dialog>
    <!-- 设置大区代理 -->
    <el-dialog
      title="提示"
      :visible.sync="agentFormVisible"
      :close-on-click-modal="false"
      width="30%"
      @close="closeAgentDialog(false)"
    >
      <div>确认设置【{{ agentName.name }}】为大区代理吗？</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAgentDialog(false)">取消</el-button>
        <el-button type="primary" @click="saveAgentInfo" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="当前用户业绩"
      :visible.sync="checkShow"
      :close-on-click-modal="false"
      width="30%"
      @close="onCloseCheck"
    >
      <div class="check-box">
        <div class="check-left-box">
          用户ID：
        </div>
        <div class="check-right-box">
          {{ curRow && curRow.id }}
        </div>
      </div>
      <div class="check-box">
        <div class="check-left-box">
          用户手机号：
        </div>
        <div class="check-right-box">
          {{ curRow && curRow.mobile }}
        </div>
      </div>
      <div class="check-box">
        <div class="check-left-box">
          用户订单金额：
        </div>
        <div class="check-right-box">
          {{ curData && curData.totalOrderAmount }}
        </div>
      </div>
      <div class="check-box">
        <div class="check-left-box">
          用户下级数量：
        </div>
        <div class="check-right-box">
          {{ curData && curData.totalUsers }}
        </div>
      </div>
      <div class="check-box">
        <div class="check-left-box">
          用户订单数量：
        </div>
        <div class="check-right-box">
          {{ curData && curData.orderCount }}
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="onCloseCheck">dw</el-button> -->
        <el-button type="primary" @click="onCloseCheck" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getMemberList,
  switchStatus,
  editMember,
  rechargeMember,
  getUserAccount,
  exportUserList,
  getAcctFlow,
  getJuniors,
  getJuniorSummary,
  setAgentInfo,
  setRegionAgentInfo,
  getUserPerformance
} from "@/api/member";
import { getAgentWithdrawInfoList } from "@/api/agent";
import { getGradeList } from "@/api/system";
import { formatApiDate } from "@/utils/utils";
import {
  getValue,
  MEMBER_STATUS,
  MEMBER_CER_STATUS,
  ACCOUNT_TYPE,
  BALANCE_TYPE,
  CONTRACT_STATUS
} from "@/utils/enumUtile";
import md5 from "js-md5";
import DataPicker from "@/views/components/dataPicker.vue";
import { uploadXlsx } from "@/utils";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    MEMBER_STATUS() {
      return MEMBER_STATUS;
    },
    MEMBER_CER_STATUS() {
      return MEMBER_CER_STATUS;
    },
    ACCOUNT_TYPE() {
      return ACCOUNT_TYPE;
    },
    BALANCE_TYPE() {
      return BALANCE_TYPE;
    },
    CONTRACT_STATUS_LIST() {
      return CONTRACT_STATUS;
    }
  },
  components: { DataPicker },
  filters: {},
  data() {
    const validatePass = (rule, value, callback) => {
      if (value.length <= 0) {
        callback(new Error("密码不能为空"));
      } else if (value.length < 6) {
        callback(new Error("密码不能小于6位"));
      } else {
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value.length < 6) {
        callback(new Error("密码不能小于6位"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      isDai: false,
      curRow: null,
      daiList: [],
      selectValue: "",
      agentName: "", // 大区代理姓名
      list: null,
      total: 0,
      listLoading: false,
      agentFormVisible: false, // 设置大区代理
      listQuery: {
        page: 1,
        pageSize: 20,
        keyword: null,
        userId: null,
        gradeId: null,
        status: null,
        certStatus: null,
        createStartTime: null,
        createEndTime: null
      },
      gradeOption: [], // 等级
      dialogFormVisible: false, // 新增会员
      rules: {
        mobile: [{ required: true, message: "手机号码不能为空", trigger: "change" }],
        password: [{ required: true, trigger: "blur", validator: validatePass }],
        password2: [
          {
            required: true,
            trigger: "blur",
            validator: validatePass2
          }
        ],
        inviteCode: [{ required: true, message: "邀请码不能为空", trigger: "change" }]
      },
      form: {
        id: 0,
        mobile: null, //手机号码
        inviteCode: null, // 邀请码
        password: null, // 登陆密码
        password2: null // 二次登陆登陆密码
      },
      btnLoading: false,
      rechargeVisible: false, // 充值
      rechargeRules: {
        amount: [{ required: true, message: "充值金额不能为空", trigger: "change" }],
        type: [{ required: true, message: "类型不能为空", trigger: "change" }]
      },
      rechargeForm: {
        id: 0,
        category: null,
        amount: 0,
        type: null
      },
      rechargeBtnLoading: false,
      userAccountList: [], // 会员账户余额
      userAccountLoading: false,
      userAccountVisible: false,
      userAccountLogList: [], // 会员账户流水
      userAccountLogLoading: false,
      userAccountLogVisible: false,
      userAccountLogForm: {
        id: 0,
        category: null,
        page: 1,
        pageSize: 10
      },
      userAccountLogTotal: 0,
      userAccountLogObj: {}, // 选中的对象
      accountLogActive: "cur", // 标签的状态
      juniorsVisible: false,
      juniorsLoading: false,
      juniorsList: [],
      juniorsForm: {
        page: 1,
        pageSize: 10,
        id: null
      },
      juniorsTotal: 0,
      juniorsStatisticsVisible: false,
      juniorsStatisticsLoading: false,
      juniorsStatisticsObj: {},
      curRow: null,
      checkShow: false,
      curData: null
    };
  },
  created() {
    if (this.$route.query.isDetailPage) {
      try {
        const savedState = sessionStorage.getItem("pageState");
        // 只有当 savedState 存在且是有效的 JSON 字符串时才恢复状态
        if (savedState) {
          const parsedState = JSON.parse(savedState);
          // 确保解析后的数据是对象类型
          if (parsedState && typeof parsedState === "object") {
            this.listQuery = { ...this.listQuery, ...parsedState };
          }
        }
        sessionStorage.removeItem("pageState");
      } catch (error) {
        console.error("恢复页面状态失败:", error);
        // 发生错误时不改变原有的 listQuery
      }
    }
    this.getList();
    this.getGrade();
    this.getDai();
  },
  watch: {},
  methods: {
    getValue,
    onCheck(row) {
      let params = {
        userId: row.id
      };
      if (this.listQuery.createStartTime) {
        params["startTime"] = this.listQuery.createStartTime;
        params["endTime"] = this.listQuery.createEndTime;
      }

      getUserPerformance(params).then(res => {
        this.curData = res.data;
        this.curRow = row;
        this.checkShow = true;
        console.log("paramsparams", params, row, res.data);
      });
    },
    onCloseCheck() {
      this.curRow = null;
      this.checkShow = false;
      this.curData = null;
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    /**
     * 查询等级
     */
    async getGrade() {
      const resp = await getGradeList();
      if (resp && resp.bizcode === 100) {
        this.gradeOption = resp.data;
      }
    },
    /**
     * 审核页面
     */
    jumpExamine(row) {
      this.$router.push({ path: "/member/examine/" + row.id });
      sessionStorage.setItem("pageState", JSON.stringify(this.listQuery));
    },
    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      console.log("参数2", params);
      getMemberList(params)
        .then(response => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    /**
     * 切换状态
     */
    async checkStatus(row) {
      const deleteGoodsMsg = row.status === 0 ? "确认要冻结该会员？" : "确认要解冻该会员";
      this.$confirm(deleteGoodsMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const params = {
          id: row.id,
          status: row.status === 1 ? 0 : 1
        };
        switchStatus(params).then(resp => {
          if (resp && resp.bizcode === 100) {
            this.getList();
            this.$notify({
              title: "成功",
              message: "修改成功",
              type: "success",
              duration: 2000
            });
          }
        });
      });
    },
    setAgent(val, row) {
      this.agentFormVisible = true;
      this.agentName = row;
    },
    closeAgentDialog(status) {
      this.agentFormVisible = status;
    },
    async saveAgentInfo() {
      const params = {
        userId: this.agentName.id
      };
      setRegionAgentInfo(params).then(resp => {
        if (resp && resp.bizcode === 100) {
          this.$notify({
            title: "成功",
            message: "设置成功",
            type: "success",
            duration: 2000
          });
          this.getList();
          this.agentFormVisible = false;
        } else {
          this.$notify({
            title: "失败",
            message: "设置失败",
            type: "error",
            duration: 2000
          });
          this.agentFormVisible = false;
        }
      });
    },
    onDaiShe() {
      console.log("sfdafsfas");
      if (this.selectValue == "") {
        this.$message.error("请先选择代理商级别");
        return;
      }
      let params = {
        userId: this.curRow.id,
        agentId: this.selectValue
      };
      setAgentInfo(params).then(resp => {
        if (resp && resp.bizcode === 100) {
          this.$notify({
            title: "成功",
            message: "设置成功",
            type: "success",
            duration: 2000
          });
          this.onClose();
          this.getList();
        }
      });
    },
    onClose() {
      this.curRow = null;
      this.isDai = false;
      this.selectValue = "";
    },
    checkDialogFormVisible(status) {
      if (!status) {
        this.$refs.form.resetFields();
      }
      this.dialogFormVisible = status;
    },
    saveAddOrEditData() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const form = this.form;
          const params = {
            mobile: form.mobile,
            inviteCode: form.inviteCode,
            password: md5(form.password)
          };
          this.btnLoading = true;
          editMember(params)
            .then(() => {
              this.getList();
              this.checkDialogFormVisible(false);
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },
    getDai() {
      this.listLoading = true;
      getAgentWithdrawInfoList({ page: 1, pageize: 1000 }).then(res => {
        this.daiList = res.data.entitys;
        this.listLoading = false;
      });
    },
    /**
     * 代理商设置
     * */
    onAgentSetting(row) {
      this.isDai = true;
      this.curRow = row;
      // console.log('代理商设置', status, obj)
    },
    // ===================== 充值 start =====================

    /**
     * 切换用户账号
     * @param status
     */
    checkUserAccountVisible(status, obj) {
      if (status && obj && Object.keys(obj).length !== 0) {
        this.rechargeForm.id = obj.id;
        this.getRechargeUserList();
      } else {
        this.rechargeForm.id = 0;
      }
      this.userAccountVisible = status;
    },
    /**
     * 查询充值会员列表
     */
    getRechargeUserList() {
      this.userAccountLoading = true;
      const params = {
        id: this.rechargeForm.id
      };
      getUserAccount(params)
        .then(resp => {
          this.userAccountList = resp.data;
        })
        .finally(() => {
          this.userAccountLoading = false;
        });
    },
    /**
     * 充值
     */
    checkRechargeVisible(status, obj) {
      if (status && obj && Object.keys(obj).length !== 0) {
        this.rechargeForm.category = obj.categoty;
      } else {
        this.rechargeForm.category = null;
        this.$refs.rechargeForm.resetFields();
      }
      this.rechargeVisible = status;
    },
    /**
     * 确认充值
     */
    saveRechargeData() {
      this.$refs["rechargeForm"].validate(valid => {
        if (valid) {
          const form = this.rechargeForm;
          const params = {
            ...form
          };
          this.rechargeBtnLoading = true;
          rechargeMember(params)
            .then(() => {
              this.getRechargeUserList();
              this.checkRechargeVisible(false);
              this.$notify({
                title: "成功",
                message: "充值成功",
                type: "success",
                duration: 2000
              });
            })
            .finally(() => {
              this.rechargeBtnLoading = false;
            });
        }
      });
    },
    // ===================== 充值 end =====================

    // ===================== 会员账户流水 start =====================

    /**
     * 切换用户账号
     * @param status
     */
    checkUserAccountLogVisible(status, obj) {
      console.log("objobjobjobj", obj);
      if (status && obj && Object.keys(obj).length !== 0) {
        this.userAccountLogForm.category = obj.categoty;
        this.userAccountLogObj = obj;
        this.handleAccountLogClick({ name: "cur" });
      } else {
        this.userAccountLogForm.id = 0;
      }
      this.userAccountLogVisible = status;
    },
    /**
     * 切换tab
     * @param tab
     */
    handleAccountLogClick(tab) {
      this.userAccountLogForm.page = 1;
      this.userAccountLogForm.pageSize = 10;
      const params = {
        page: 1,
        pageSize: 10
      };
      if (tab.name === "cur") {
        params.id = this.userAccountLogObj.curId;
      } else if (tab.name === "lock") {
        params.id = this.userAccountLogObj.lockId;
      }
      if (!params.id) {
        this.userAccountLogList = [];
        return;
      } else {
        this.userAccountLogForm.id = params.id;
      }
      this.getRechargeUserLogList();
    },
    /**
     * 查询充值会员列表
     */
    getRechargeUserLogList() {
      this.userAccountLogLoading = true;
      const params = {
        ...this.userAccountLogForm
      };
      getAcctFlow(params)
        .then(resp => {
          this.userAccountLogList = resp.data.entitys;
          this.userAccountLogTotal = resp.data.totalCount;
        })
        .finally(() => {
          this.userAccountLogLoading = false;
        });
    },

    handleSizeLogChange(val) {
      this.userAccountLogForm.pageSize = val;
      this.getRechargeUserLogList();
    },
    handleCurrentLogChange(val) {
      this.userAccountLogForm.page = val;
      this.getRechargeUserLogList();
    },

    // ===================== 会员账户流水 end =====================

    /**
     * 获取时间
     * @param type
     * @param value
     */
    getPickerValueFunc(type, value) {
      if (type === "create") {
        this.listQuery.createStartTime = value[0];
        this.listQuery.createEndTime = value[1];
      }
    },

    /**
     * 导出
     */
    handleExport() {
      const form = this.listQuery;
      const params = {
        ...form
      };
      exportUserList(params).then(response => {
        uploadXlsx(response, "会员表");
      });
    },
    // ===================== 会员账户流水 start =====================
    handleJuniorsSizeChange(val) {
      this.juniorsForm.pageSize = val;
      this.getList();
    },
    handleJuniorsCurrentChange(val) {
      this.juniorsForm.page = val;
      this.getList();
    },

    checkJuniorsVisible(status, item) {
      if (status) {
        this.form.id = item.id;
        this.juniorsLoading = true;
        const params = this.form;
        getJuniors(params)
          .then(res => {
            if (res && res.bizcode === 100) {
              this.juniorsList = res.data.entitys;
              this.juniorsTotal = res.data.totalCount;
            }
          })
          .finally(() => {
            this.juniorsLoading = false;
          });
      } else {
        this.userId = null;
      }
      this.juniorsVisible = status;
    },

    checkJuniorsStatisticsVisible(status, item) {
      if (status) {
        const params = {
          userId: item.id
        };
        getJuniorSummary(params)
          .then(res => {
            if (res && res.bizcode === 100) {
              this.juniorsStatisticsObj = res.data;
            }
          })
          .finally(() => {
            this.juniorsLoading = false;
          });
      }
      this.juniorsStatisticsVisible = status;
    }
    // ===================== 会员账户流水 end =====================
  }
};
</script>
<style scoped lang="scss">
.check-box {
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  .check-left-box {
    width: 150px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }
  .check-right-box {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}
.dialog-view {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 30px;
  position: relative;
  .dialog-content {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .dialog-left {
      width: 200px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
    }
    .dialog-right {
      flex: 1;
      margin-left: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
  .dia-pos {
    position: absolute;
    top: -70px;
  }
}
.el-dropdown-link {
  cursor: pointer;
  margin-left: 10px;
}
.comm_but_warp {
  margin-bottom: 10px;
}
.dialog-footer {
  display: flex;
  justify-content: right;
  width: 100%;
}
</style>
